/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LevelType } from '../../models/level-type';
import { MembershipSummaryResponse } from '../../models/membership-summary-response';

export interface GetMembershipsSummary$Params {
  level: LevelType;
}

export function getMembershipsSummary(http: HttpClient, rootUrl: string, params: GetMembershipsSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipSummaryResponse>> {
  const rb = new RequestBuilder(rootUrl, getMembershipsSummary.PATH, 'get');
  if (params) {
    rb.path('level', params.level, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembershipSummaryResponse>;
    })
  );
}

getMembershipsSummary.PATH = '/api/company/memberships/{level}/summary';
